// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfx_a bhu_vc bhu_rm bhu_wf"};